module.exports = __webpack_public_path__ + "img/HABLAR_KIKE.9bb8c6f6.png";